import clsx from 'clsx';

interface IconButtonSkeletonProps {
    className?: string;
}

const IconButtonSkeleton = ({ className = '' }: IconButtonSkeletonProps) => {
    return (
        <div className="absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center bg-gray-100/50 backdrop-blur-sm">
            <div className={clsx('flex h-full w-full items-center justify-center overflow-hidden', className)}>
                <div className="h-1/4 w-1/2 animate-pulse rounded-sm bg-gray-200" />
            </div>
        </div>
    );
};

export default IconButtonSkeleton;
